import React from "react";
import axios from "axios";
import { Box, Botao, Alerta, TipoAlerta, Form, CampoTexto, TipoBotao, Combo } from "@intechprev/componentes-web";
import { RecadastramentoService } from "../../services";
import { WebRecadParticipanteDadosEntidade, UFEntidade } from "../../entidades";
import { Passos } from ".";

interface Props {
  setDadosPasso: any;
  Dados: any;
  DadosOriginais: WebRecadParticipanteDadosEntidade;
  Avancar: () => void;
  Voltar: () => void;
  NumeroPassoAtual: number;
}

interface State {
  Cep: string;
  Endereco: string;
  Numero: string;
  Complemento: string;
  Bairro: string;
  Cidade: string;
  Estado: string;
  Email: string;
  TelefoneResidencial: string;
  TelefoneCelular: string;
  ListaUF: Array<UFEntidade>;
}

export class Passo4 extends React.Component<Props, State> {
  private form = React.createRef<Form>();
  private alerta = React.createRef<Alerta>();

  constructor(props: Props) {
    super(props);

    this.state = {
      Cep: "",
      Endereco: "",
      Numero: "",
      Complemento: "",
      Bairro: "",
      Cidade: "",
      Estado: "",
      Email: "",
      TelefoneResidencial: "",
      TelefoneCelular: "",
      ListaUF: new Array<UFEntidade>(),
    };
  }

  componentDidMount = async () => {
    try {
      // this.page.current.loading(false);

      const ListaUF = await RecadastramentoService.BuscarListaUF();

      this.setState({
        Cep: this.props.Dados.Cep || this.props.DadosOriginais.CEP_ENTID || "",
        Endereco: this.props.Dados.Endereco || this.props.DadosOriginais.END_ENTID || "",
        Numero: this.props.Dados.Numero || this.props.DadosOriginais.NR_END_ENTID || "",
        Complemento: this.props.Dados.Complemento || this.props.DadosOriginais.COMP_END_ENTID || "",
        Bairro: this.props.Dados.Bairro || this.props.DadosOriginais.BAIRRO_ENTID || "",
        Cidade: this.props.Dados.Cidade || this.props.DadosOriginais.CID_ENTID || "",
        Estado: this.props.Dados.Estado || this.props.DadosOriginais.UF_ENTID || "",
        Email: this.props.Dados.Email || this.props.DadosOriginais.EMAIL_AUX || "",
        TelefoneResidencial: this.props.Dados.TelefoneResidencial || this.props.DadosOriginais.FONE_ENTID || "",
        TelefoneCelular: this.props.Dados.TelefoneCelular || this.props.DadosOriginais.FONE_CELULAR || "",
        ListaUF,
      });
    } catch (e) {
      const err: any = e;
      await this.alerta.current.adicionarErro(err.response ? err.response.data : err);
    }
  };

  BuscarCep = async () => {
    const cepres = (await axios.get(`https://viacep.com.br/ws/${this.state.Cep}/json/`)).data;

    this.setState({
      Endereco: cepres.logradouro,
      Complemento: cepres.complemento,
      Bairro: cepres.bairro,
      Cidade: cepres.localidade,
      Estado: cepres.uf,
    });
  };

  SalvarDados = () => {
    const d = {
      Cep: this.state.Cep,
      Endereco: this.state.Endereco,
      Numero: this.state.Numero,
      Complemento: this.state.Complemento,
      Bairro: this.state.Bairro,
      Cidade: this.state.Cidade,
      Estado: this.state.Estado,
      Email: this.state.Email,
      TelefoneResidencial: this.state.TelefoneResidencial,
      TelefoneCelular: this.state.TelefoneCelular,
    };
    this.props.setDadosPasso(Passos.Passo4, d);
  };

  Voltar = () => {
    this.SalvarDados();
    this.props.Voltar();
  };

  Proximo = async () => {
    try {
      await this.alerta.current.limparErros();
      await this.form.current.validar();

      if (this.form.current.isValido()) {
        await RecadastramentoService.ValidarEmail(this.state.Email);

        this.SalvarDados();
        this.props.Avancar();
      }
    } catch (e) {
      const err: any = e;
      await this.alerta.current.adicionarErro(err.response ? err.response.data : err);
    }
  };

  render() {
    return (
      <Box titulo={`Passo ${this.props.NumeroPassoAtual} - Identificação Domiciliar`}>
        <Form ref={this.form}>
          <CampoTexto
            contexto={this}
            nome={"Cep"}
            titulo={"CEP"}
            obrigatorio
            valor={this.state.Cep}
            mascara={"99999-999"}
            grupo
            tituloBotao={"Consultar"}
            onBotaoClick={this.BuscarCep}
          />

          <CampoTexto contexto={this} nome={"Endereco"} titulo={"Endereço"} obrigatorio valor={this.state.Endereco} max={60} />

          <CampoTexto contexto={this} nome={"Numero"} titulo={"Número"} obrigatorio valor={this.state.Numero} max={6} />

          <CampoTexto contexto={this} nome={"Complemento"} titulo={"Complemento"} valor={this.state.Complemento} max={30} />

          <CampoTexto contexto={this} nome={"Bairro"} titulo={"Bairro"} obrigatorio valor={this.state.Bairro} max={30} />

          <CampoTexto contexto={this} nome={"Cidade"} titulo={"Cidade"} obrigatorio valor={this.state.Cidade} max={40} />

          <Combo
            contexto={this}
            nome={"Estado"}
            titulo={"Estado"}
            obrigatorio
            valor={this.state.Estado}
            opcoes={this.state.ListaUF}
            nomeMembro={"DS_UNID_FED"}
            valorMembro={"CD_UNID_FED"}
            textoVazio={"Escolha o seu Estado"}
          />

          <CampoTexto contexto={this} nome={"Email"} titulo={"E-mail Pessoal"} obrigatorio valor={this.state.Email} max={60} />

          <CampoTexto
            contexto={this}
            nome={"TelefoneResidencial"}
            titulo={"Telefone Residencial"}
            valor={this.state.TelefoneResidencial}
            mascara={"(99)9999-9999"}
          />

          <CampoTexto
            contexto={this}
            nome={"TelefoneCelular"}
            titulo={"Telefone Celular"}
            valor={this.state.TelefoneCelular}
            obrigatorio={this.props.DadosOriginais.IND_FATCA !== "S"}
            mascara={"(99)99999-9999"}
          />

          <Alerta tipo={TipoAlerta.danger} ref={this.alerta} padraoFormulario />

          <Botao onClick={this.Voltar} titulo={"Voltar"} className={"m-2"} tipo={TipoBotao.light} icone={"angle-double-left"} iconeDireita />

          <Botao onClick={this.Proximo} titulo={"Continuar"} icone={"angle-double-right"} iconeDireita />
        </Form>
      </Box>
    );
  }
}
